import React from "react";

import {
  Button,
  ButtonProps,
  Link,
  LinkProps,
} from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";

type MobileNavItemWrapperProps = {
  isActive: boolean;
};

type NavLinkWrapperProps = LinkProps & MobileNavItemWrapperProps;

const NavLinkWrapper = styled(Link)<NavLinkWrapperProps>`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  color: ${(props) =>
    themeGet(
      props.isActive ? "colors.secondary" : "colors.typography.inactive"
    )(props)};
  &:hover,
  &:focus,
  &:active {
    outline: none;
    text-decoration: none;
    & > p, & > svg {
      color: ${(props) => themeGet("colors.typography.inactive")(props)}}
    }
  }
  & > p,
  & > svg {
    color: ${(props) =>
      themeGet(
        props.isActive ? "colors.secondary" : "colors.typography.inactive"
      )(props)};
  }
`;

type NavButtonWrapperProps = ButtonProps & MobileNavItemWrapperProps;

const NavButtonWrapper = styled(Button)<NavButtonWrapperProps>`
  flex: 1;
  height: 100%;
  padding: 0;
  font-size: 12px;
  background: transparent;
  min-width: 0 !important;
  border: none;
  color: ${(props) =>
    themeGet(
      props.isActive ? "colors.secondary" : "colors.typography.inactive"
    )(props)};
  text-transform: none;
  &:hover:not(:disabled):not([disabled]) {
    background-color: transparent;
  }
  &:active {
    box-shadow: none;
  }
  p,
  svg {
    color: ${(props) =>
      themeGet(
        props.isActive ? "colors.secondary" : "colors.typography.inactive"
      )(props)};
  }
`;

export type MobileNavItemProps = {
  isActive: boolean;
  url?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

export const MobileNavItem = ({
  isActive,
  url,
  onClick,
  children,
  ...props
}: MobileNavItemProps) => {
  const NavItemWrapper = url ? NavLinkWrapper : NavButtonWrapper;

  return (
    <NavItemWrapper
      isActive={isActive}
      href={url}
      onClick={onClick}
      aria-current={isActive && "page"}
      {...props}
    >
      {children}
    </NavItemWrapper>
  );
};
